import type { ContractCopyDto } from "../../types/ContractCopyDto";
import type { ContractCopyEntity } from "../../types/ContractCopyEntity";

export const ContractCopyEntityToCopyDto = ({ ...rest }: Readonly<ContractCopyEntity>): ContractCopyDto => {
    return { ...rest };
};
